import Page404 from "../pages/page404/index.vue";
const routes = [
  {
    name: "pcIndex",
    path: "/",
    meta: { index: 1, title: "首页" },
    component: (resolve) =>
      require(["@/pages/download/newDownload.vue"], resolve),
  },
  {
    name: "levelIntroduce",
    path: "/levelIntroduce",
    meta: { index: 1, title: "等级管理" },
    component: (resolve) =>
      require(["@/pages/level/levelIntroduce.vue"], resolve),
  },
  {
    name: "equityLevel",
    path: "/equityLevel",
    meta: { index: 1, title: "等级权益" },
    component: (resolve) => require(["@/pages/level/equityLevel.vue"], resolve),
  },

  {
    name: "buyMember",
    path: "/buyMember",
    meta: { index: 1, title: "VIP会员" },
    component: (resolve) => require(["@/pages/level/buyMember.vue"], resolve),
  },
  {
    name: "profitMain",
    path: "/profitMain",
    meta: { index: 1, title: "收益" },
    component: (resolve) => require(["@/pages/profit/profitMain.vue"], resolve),
  },
  {
    name: "hasProfit",
    path: "/hasProfit",
    meta: { index: 1, title: "提现" },
    component: (resolve) => require(["@/pages/profit/hasProfit.vue"], resolve),
  },
  {
    name: "exchangeCoin",
    path: "/exchangeCoin",
    meta: { index: 1, title: "兑换" },
    component: (resolve) =>
      require(["@/pages/profit/exchangeCoin.vue"], resolve),
  },
  {
    name: "giftProfit",
    path: "/giftProfit",
    meta: { index: 1, title: "礼物记录" },
    component: (resolve) => require(["@/pages/profit/giftProfit.vue"], resolve),
  },
  {
    name: "weekProfit",
    path: "/weekProfit",
    meta: { index: 1, title: "收益记录" },
    component: (resolve) => require(["@/pages/profit/weekProfit.vue"], resolve),
  },
  {
    name: "otayoniiInfo",
    path: "/otayoniiInfo",
    meta: { index: 1, title: "礼物丸值明细" },
    component: (resolve) =>
      require(["@/pages/profit/otayoniiInfo.vue"], resolve),
  },
  {
    name: "addInfo",
    path: "/addInfo",
    meta: { index: 1, title: "信息完善" },
    component: (resolve) => require(["@/pages/profit/addInfo.vue"], resolve),
  },
  {
    name: "familyMain",
    path: "/familyMain",
    meta: { index: 1, title: "家族管理" },
    component: (resolve) => require(["@/pages/family/familyMain.vue"], resolve),
  },
  {
    name: "salaryMain",
    path: "/salaryMain",
    meta: { index: 1, title: "主播数据" },
    component: (resolve) => require(["@/pages/family/salaryMain.vue"], resolve),
  },
  {
    name: "grant",
    path: "/grant",
    meta: { index: 1, title: "工资发放" },
    component: (resolve) => require(["@/pages/family/grant.vue"], resolve),
  },
  {
    name: "openLiveRate",
    path: "/openLiveRate",
    meta: { index: 1, title: "开播率" },
    component: (resolve) =>
      require(["@/pages/family/openLiveRate.vue"], resolve),
  },
  {
    name: "payroll",
    path: "/payroll",
    meta: { index: 1, title: "丸值分配" },
    component: (resolve) => require(["@/pages/family/payroll.vue"], resolve),
  },
  {
    name: "vjSalary",
    path: "/vjSalary",
    meta: { index: 1, title: "主播薪水" },
    component: (resolve) => require(["@/pages/family/vjSalary.vue"], resolve),
  },
  {
    name: "micTime",
    path: "/micTime",
    meta: { index: 1, title: "主播麦时" },
    component: (resolve) => require(["@/pages/family/micTime.vue"], resolve),
  },
  {
    name: "anchroOtayonii",
    path: "/anchroOtayonii",
    meta: { index: 1, title: "主播丸值明细" },
    component: (resolve) =>
      require(["@/pages/family/anchroOtayonii.vue"], resolve),
  },
  {
    name: "anchorExchange",
    path: "/anchorExchange",
    meta: { index: 1, title: "主播提现明细" },
    component: (resolve) =>
      require(["@/pages/family/anchorExchange.vue"], resolve),
  },
  {
    name: "anchorCenter",
    path: "/anchorCenter",
    meta: { index: 1, title: "主播中心" },
    component: (resolve) =>
      require(["@/pages/familyManagement/anchorCenter.vue"], resolve),
  },
  {
    name: "familyManagement",
    path: "/familyManagement",
    meta: { index: 1, title: "家族管理" },
    component: (resolve) =>
      require(["@/pages/familyManagement/index.vue"], resolve),
  },
  {
    name: "coinExchange",
    path: "/coinExchange",
    meta: { index: 1, title: "金币兑换" },
    component: (resolve) =>
      require(["@/pages/familyManagement/coinExchange.vue"], resolve),
  },

  {
    name: "anchorList2",
    path: "/anchorList2",
    meta: { index: 1, title: "主播列表" },
    component: (resolve) =>
      require(["@/pages/familyManagement/anchorList.vue"], resolve),
  },
  {
    name: "unionManagement",
    path: "/unionManagement",
    meta: { index: 1, title: "工会管理" },
    component: (resolve) =>
      require(["@/pages/familyManagement/unionManagement.vue"], resolve),
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: { index: 1, title: "统计" },
    component: (resolve) =>
      require(["@/pages/familyManagement/statistics.vue"], resolve),
  },
  {
    name: "familyInvitation",
    path: "/familyInvitation",
    meta: { index: 1, title: "家族长邀请" },
    component: (resolve) =>
      require(["@/pages/familyManagement/familyInvitation.vue"], resolve),
  },
  {
    name: "userInvitation",
    path: "/userInvitation",
    meta: { index: 1, title: "用户邀请" },
    component: (resolve) =>
      require(["@/pages/familyManagement/userInvitation.vue"], resolve),
  },
  {
    name: "landingPage",
    path: "/landingPage",
    meta: { index: 1, title: "邀请落地页" },
    component: (resolve) =>
      require(["@/pages/familyManagement/landingPage.vue"], resolve),
  },

  {
    name: "familyInvitationDetail",
    path: "/familyInvitationDetail",
    meta: { index: 1, title: "邀请详情" },
    component: (resolve) =>
      require(["@/pages/familyManagement/familyInvitationDetail.vue"], resolve),
  },

  {
    name: "activityRules",
    path: "/activityRules",
    meta: { index: 1, title: "活动规则" },
    component: (resolve) =>
      require(["@/pages/activity/activityRules.vue"], resolve),
  },

  {
    name: "liveDetails",
    path: "/liveDetails",
    meta: { index: 1, title: "直播详情" },
    component: (resolve) =>
      require(["@/pages/familyManagement/liveDetails.vue"], resolve),
  },
  {
    name: "liveDetails2",
    path: "/liveDetails2",
    meta: { index: 1, title: "直播详情" },
    component: (resolve) =>
      require(["@/pages/familyManagement/liveDetails2.vue"], resolve),
  },
  {
    name: "personalData",
    path: "/personalData",
    meta: { index: 1, title: "个人数据" },
    component: (resolve) =>
      require(["@/pages/familyManagement/personalData.vue"], resolve),
  },
  {
    name: "withdrawal",
    path: "/withdrawal",
    meta: { index: 1, title: "提现" },
    component: (resolve) =>
      require(["@/pages/familyManagement/withdrawal.vue"], resolve),
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: { index: 1, title: "提现" },
    component: (resolve) =>
      require(["@/pages/merchants/withdraw.vue"], resolve),
  },

  {
    name: "withdrawalRecords",
    path: "/withdrawalRecords",
    meta: { index: 1, title: "提现记录" },
    component: (resolve) =>
      require(["@/pages/familyManagement/withdrawalRecords.vue"], resolve),
  },

  {
    name: "accountBalance",
    path: "/accountBalance",
    meta: { index: 1, title: "家族管理" },
    component: (resolve) =>
      require(["@/pages/familyManagement/accountBalance.vue"], resolve),
  },

  {
    name: "knapsackList",
    path: "/knapsackList",
    meta: { index: 1, title: "特效明细" },
    component: (resolve) =>
      require(["@/pages/family/knapsackList.vue"], resolve),
  },
  {
    name: "roomCm",
    path: "/roomCm",
    meta: { index: 1, title: "房间流水" },
    component: (resolve) => require(["@/pages/family/roomCm.vue"], resolve),
  },
  {
    name: "fail",
    path: "/failMain",
    meta: { index: 1, title: "登录失效" },
    component: (resolve) => require(["@/pages/fail/failMain.vue"], resolve),
  },
  {
    name: "index",
    path: "/index",
    meta: { index: 1, title: "下载页" },
    component: (resolve) => require(["@/pages/download/index.vue"], resolve),
  },
  {
    name: "newDownload",
    path: "/newDownload",
    meta: { index: 1, title: "应用下载" },
    component: (resolve) =>
      require(["@/pages/download/newDownload.vue"], resolve),
  },
  {
    name: "anchorExchanges",
    path: "/anchorExchanges",
    meta: { index: 1, title: "主播赠送" },
    component: (resolve) =>
      require(["@/pages/activity/anchorExchanges.vue"], resolve),
  },
  {
    name: "anchorExchangeList",
    path: "/anchorExchangeList",
    meta: { index: 1, title: "赠送明细" },
    component: (resolve) =>
      require(["@/pages/activity/anchorExchangeList.vue"], resolve),
  },
  {
    name: "agree",
    path: "/agree",
    meta: { index: 1, title: "用户协议" },
    component: (resolve) => require(["@/pages/user/agree.vue"], resolve),
  },
  {
    name: "conceal",
    path: "/conceal",
    meta: { index: 1, title: "隐私政策" },
    component: (resolve) => require(["@/pages/user/conceal.vue"], resolve),
  },
  {
    name: "anchor",
    path: "/anchor",
    meta: { index: 1, title: "主播协议" },
    component: (resolve) => require(["@/pages/user/anchor.vue"], resolve),
  },
  {
    name: "interactionRules",
    path: "/interactionRules",
    meta: { index: 1, title: "互动规范" },
    component: (resolve) =>
      require(["@/pages/user/interactionRules.vue"], resolve),
  },
  {
    name: "crackDownCashback",
    path: "/crackDownCashback",
    meta: { index: 1, title: "严打返现公告" },
    component: (resolve) =>
      require(["@/pages/user/crackDownCashback.vue"], resolve),
  },
  {
    name: "help",
    path: "/help",
    meta: { index: 1, title: "帮助中心" },
    component: (resolve) =>
      require(["@/pages/user/help.vue"], resolve),
  },
  {
    name: "greenLive",
    path: "/greenLive",
    meta: { index: 1, title: "绿色直播" },
    component: (resolve) => require(["@/pages/user/greenLive.vue"], resolve),
  },
  {
    // 旧地址 /recharge 统一跳转充值中心
    name: "recharge",
    path: "/recharge",
    redirect: "/rechargeCenter",
  },
  {
    name: "rechargeProtocol",
    path: "/rechargeProtocol",
    meta: { index: 1, title: "充值协议" },
    component: (resolve) => require(["@/pages/user/recharge.vue"], resolve),
  },
  {
    name: "userServiceAgreement",
    path: "/userServiceAgreement",
    meta: { index: 1, title: "用户服务协议" },
    component: (resolve) =>
      require(["@/pages/user/userServiceAgreement.vue"], resolve),
  },
  {
    name: "sdkPrivacyList",
    path: "/sdkPrivacyList",
    meta: { index: 1, title: "第三方信息共享清单" },
    component: (resolve) =>
      require(["@/pages/user/sdkPrivacyList.vue"], resolve),
  },
  {
    name: "permissionInfo",
    path: "/permissionInfo",
    meta: { index: 1, title: "产品权限申请与使用情况说明" },
    component: (resolve) =>
      require(["@/pages/user/permissionInfo.vue"], resolve),
  },
  {
    name: "privacyList",
    path: "/privacyList",
    meta: { index: 1, title: "个人信息收集清单" },
    component: (resolve) =>
      require(["@/pages/user/privacyList.vue"], resolve),
  },
  // 【已下线-活跃任务】如需恢复，取消注释即可
  // {
  //   name: "intregal",
  //   path: "/intregal",
  //   meta: { index: 1, title: "活跃任务" },
  //   component: (resolve) => require(["@/pages/activity/intregal.vue"], resolve),
  // },
  {
    name: "rechargeCenter",
    path: "/rechargeCenter",
    meta: { index: 1, title: "充值中心" },
    component: (resolve) =>
      require(["@/pages/user/rechargeCenter.vue"], resolve),
  },
  // 【已下线-砸金蛋】如需恢复，取消注释即可
  // {
  //   name: "goldenEggs",
  //   path: "/goldenEggs",
  //   meta: { index: 1, title: "砸金蛋" },
  //   component: (resolve) =>
  //     require(["@/pages/gameActivities/goldenEggs.vue"], resolve),
  // },
  // 【已下线-抽奖大转盘】如需恢复，取消注释即可
  // {
  //   name: "lucky-wheel",
  //   path: "/lucky-wheel",
  //   meta: { index: 1, title: "抽奖大转盘" },
  //   component: (resolve) =>
  //     require(["@/pages/gameActivities/lucky-wheel.vue"], resolve),
  // },
  {
    name: "paySuccess",
    path: "/paySuccess",
    meta: { index: 1, title: "抽奖大转盘" },
    component: (resolve) => require(["@/pages/user/paySuccess.vue"], resolve),
  },
  // 【已下线-首充活动】如需恢复，取消注释即可
  // {
  //   name: "firstChange",
  //   path: "/firstChange",
  //   meta: { index: 1, title: "首充活动" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/firstChange.vue"], resolve),
  // },
  {
    name: "contactService",
    path: "/contactService",
    meta: { index: 1, title: "联系客服" },
    component: (resolve) =>
      require(["@/pages/activity/contactService.vue"], resolve),
  },
  // 【已下线-百万赠送三重奏】如需恢复，取消注释即可
  // {
  //   name: "millionActivity",
  //   path: "/millionActivity",
  //   meta: { index: 1, title: "百万赠送三重奏" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/millionActivity.vue"], resolve),
  // },
  // 【已下线-公会招募】如需恢复，取消注释即可
  // {
  //   name: "inFamily",
  //   path: "/inFamily",
  //   meta: { index: 1, title: "公会招募" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/in_family.vue"], resolve),
  // },
  // 【已下线-每日首充活动】如需恢复，取消注释即可
  // {
  //   name: "dayFirstCharge",
  //   path: "/dayFirstCharge",
  //   meta: { index: 1, title: "每日首充活动" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/dayFirstCharge.vue"], resolve),
  // },
  // 【已下线-热门活动(51)】如需恢复，取消注释即可
  // {
  //   name: "51",
  //   path: "/51",
  //   meta: { index: 1, title: "热门活动" },
  //   component: (resolve) => require(["@/pages/activity/51.vue"], resolve),
  // },

  {
    name: "invitingActivities",
    path: "/invitingActivities",
    meta: { index: 1, title: "热门活动" },
    component: (resolve) =>
      require(["@/pages/activity/invitingActivities.vue"], resolve),
  },
  {
    name: "certificationMain",
    path: "/certificationMain",
    meta: { index: 1, title: "实名认证" },
    component: (resolve) =>
      require(["@/pages/certification/certificationMain.vue"], resolve),
  },
  {
    name: "certificationResult",
    path: "/certificationResult",
    meta: { index: 1, title: "实名认证结果" },
    component: (resolve) =>
      require(["@/pages/certification/certificationResult.vue"], resolve),
  },
  {
    name: "personalInfoAuthorization",
    path: "/personalInfoAuthorization",
    meta: { index: 1, title: "个人信息授权协议" },
    component: (resolve) =>
      require(["@/pages/certification/personalInfoAuthorization.vue"], resolve),
  },
  {
    name: "anchorList",
    path: "/anchorList",
    meta: { index: 1, title: "主播列表" },
    component: (resolve) => require(["@/pages/family/anchorList.vue"], resolve),
  },
  {
    name: "imageGenerationPage",
    path: "/imageGenerationPage",
    meta: { index: 1, title: "活动页" },
    component: (resolve) =>
      require(["@/pages/activity/imageGenerationPage.vue"], resolve),
  },
  {
    name: "imageGenerationPage2",
    path: "/imageGenerationPage2",
    meta: { index: 1, title: "活动页" },
    component: (resolve) =>
      require(["@/pages/activity/imageGenerationPage2.vue"], resolve),
  },
  // {
  //   name: "intregal",
  //   path: "/intregal",
  //   meta: { index: 1, title: "积分活动" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/intregal/index.vue"], resolve),
  // },
  {
    name: "intregalRule",
    path: "/intregalRule",
    meta: { index: 1, title: "领取规则" },
    component: (resolve) =>
      require(["@/pages/activity/intregal/rule.vue"], resolve),
  },

  {
    name: "convention",
    path: "/convention",
    meta: { index: 1, title: "文明公约" },
    component: (resolve) =>
      require(["@/pages/activity/convention.vue"], resolve),
  },
  // 【已下线-元旦活动】如需恢复，取消注释即可
  // {
  //   name: "newYearsDay",
  //   path: "/newYearsDay",
  //   meta: { index: 1, title: "元旦活动" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/newYearsDay.vue"], resolve),
  // },
  // 【已下线-红包雨活动】如需恢复，取消注释即可
  // {
  //   name: "redEnvelopeRain",
  //   path: "/redEnvelopeRain",
  //   meta: { index: 1, title: "红包雨活动" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/redEnvelopeRain.vue"], resolve),
  // },
  {
    name: "preRedirect",
    path: "/preRedirect",
    meta: { index: 1, title: "丸趣live" },
    component: (resolve) =>
      require(["@/pages/activity/preRedirect.vue"], resolve),
  },

  // 【已下线-周星榜】如需恢复，取消注释即可
  // {
  //   name: "zhouXingBang",
  //   path: "/zhouXingBang",
  //   meta: { index: 1, title: "周星榜" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/zhouXingBang.vue"], resolve),
  // },
  // {
  //   name: "zhouXingBangRule",
  //   path: "/zhouXingBangRule",
  //   meta: { index: 1, title: "周星榜规则" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/zhouXingBangRule.vue"], resolve),
  // },

  {
    name: "levelDescription",
    path: "/levelDescription",
    meta: { index: 1, title: "等级说明" },
    component: (resolve) =>
      require(["@/pages/level/levelDescription.vue"], resolve),
  },
  {
    name: "nobility",
    path: "/nobility",
    meta: { index: 1, title: "贵族" },
    component: (resolve) => require(["@/pages/nobility/index.vue"], resolve),
  },
  {
    name: "nobilityAgreement",
    path: "/nobilityAgreement",
    meta: { index: 1, title: "贵族会员服务协议" },
    component: (resolve) =>
      require(["@/pages/nobility/agreement.vue"], resolve),
  },
  {
    name: "fileUpload",
    path: "/fileUpload",
    meta: { index: 1, title: "文件上传" },
    component: (resolve) => require(["@/pages/pc/fileUpload.vue"], resolve),
  },
  {
    name: "merchantCenter",
    path: "/merchantCenter",
    meta: { index: 1, title: "商户中心" },
    component: (resolve) => require(["@/pages/pc/merchantCenter.vue"], resolve),
  },
  {
    name: "merchantCenterHuiFu",
    path: "/merchantCenterHuiFu",
    meta: { index: 1, title: "汇付商户中心" },
    component: (resolve) =>
      require(["@/pages/pc/merchantCenterHuiFu.vue"], resolve),
  },
  {
    name: "transferpage",
    path: "/transferpage",
    meta: { index: 1, title: "中转页" },
    component: (resolve) => require(["@/pages/h5/transferpage.vue"], resolve),
  },
  {
    name: "contactService",
    path: "/contactService",
    meta: { index: 1, title: "联系客服" },
    component: (resolve) =>
      require(["@/pages/activity/contactService.vue"], resolve),
  },
  // 【已下线-礼物墙说明】如需恢复，取消注释即可
  // {
  //   name: "giftWall",
  //   path: "/giftWall",
  //   meta: { index: 1, title: "礼物墙说明" },
  //   component: (resolve) => require(["@/pages/activity/giftWall.vue"], resolve),
  // },
  // 【已下线-盲盒玩法介绍】如需恢复，取消注释即可
  // {
  //   name: "nationalDayActivities",
  //   path: "/blind-box",
  //   meta: { index: 1, title: "玩法介绍" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/blind_box.vue"], resolve),
  // },
  // 【已下线-国庆活动】如需恢复，取消注释即可
  // {
  //   name: "nationalDayActivities",
  //   path: "/nationalDayActivities",
  //   meta: { index: 1, title: "国庆活动" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/nationalDayActivities.vue"], resolve),
  // },
  // 【已下线-周日活动】如需恢复，取消注释即可
  // {
  //   name: "sundayActivities",
  //   path: "/sundayActivities",
  //   meta: { index: 1, title: "周日活动" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/sundayActivities.vue"], resolve),
  // },

  {
    name: "newExchangeCoin",
    path: "/newExchangeCoin",
    meta: { index: 1, title: "金币兑换" },
    component: (resolve) =>
      require(["@/pages/profit/newExchangeCoin.vue"], resolve),
  },
  {
    name: "otayoniiExchangeCoin",
    path: "/otayoniiExchangeCoin",
    meta: { index: 1, title: "丸值兑换金币" },
    component: (resolve) =>
      require(["@/pages/profit/otayoniiExchangeCoin.vue"], resolve),
  },
  {
    name: "standardNetwork",
    path: "/standardNetwork",
    meta: { index: 1, title: "规范网络直播" },
    component: (resolve) =>
      require(["@/pages/activity/standardNetwork.vue"], resolve),
  },

  // 【已下线-大炮玩法介绍】如需恢复，取消注释即可
  // {
  //   name: "gameplayIntroduction",
  //   path: "/gameplayIntroduction",
  //   meta: { index: 1, title: "大炮玩法介绍" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/gameplayIntroduction.vue"], resolve),
  // },
  // 【已下线-心动模式玩法介绍】如需恢复，取消注释即可
  // {
  //   name: "heartbeatGameplay",
  //   path: "/heartbeatGameplay",
  //   meta: { index: 1, title: "心动模式玩法介绍" },
  //   component: (resolve) =>
  //     require(["@/pages/activity/heartbeatGameplay.vue"], resolve),
  // },

  {
    name: "myUnion",
    path: "/myUnion",
    meta: { index: 1, title: "我的工会" },
    component: (resolve) =>
      require(["@/pages/familyManagement/myUnion.vue"], resolve),
  },
  {
    name: "editUnion",
    path: "/editUnion",
    meta: { index: 1, title: "编辑公会" },
    component: (resolve) =>
      require(["@/pages/familyManagement/editUnion.vue"], resolve),
  },

  {
    path: "*",
    component: Page404, //404页面
  },
];
export default routes;
